export function getEmptyTodayActivity(period) {
  const data = {
    name: "-- NO ACTIVITY SELECTED --",
  };
  return getActivityModel(period, data);
}

function trimEllip(str, length) {
  if (str == null) return null;

  return str.length > length ? str.substring(0, length) + "..." : str;
}

function isEmpty(str) {
  return str == null || str === "" || str === "<p><br></p>";
}

export function getActivityModel(period, data) {
  const obj = {};

  obj.name = data.name;

  // format name
  // obj.name = _.startCase(_.camelCase(obj.name));

  obj.nameShort = obj.name;
  obj.description = data.description;
  obj.activityDateDescription = data.activityDateDescription;

  obj.meetingUrl = data.meetingUrl;
  obj.meetingJoinCode = data.meetingJoinCode;

  if (data.proctor) {
    obj.proctor = data.proctor;
  }
  if (data.last_name) {
    obj.proctor = data.last_name;
  }
  obj.categoryId = data.categoryId;

  if (data.iconPath) {
    obj.iconPath = data.iconPath;
  }

  // number of seats left
  obj.left = data.left;

  obj.location = data.location;
  obj.period = period;
  obj.activityDateEid = data.activityDateEid;
  obj.activityEid = data.activityEid;

  if (isEmpty(obj.activityDateDescription)) {
    obj.activityDateDescription = "-- NONE --";
  }

  if (isEmpty(obj.description)) {
    obj.description = "-- NONE --";
  }

  if (isEmpty(obj.meetingUrl)) {
    obj.meetingUrl = "-- NONE --";
  }

  if (isEmpty(obj.meetingJoinCode)) {
    obj.meetingJoinCode = "-- NONE --";
  }

  if (isEmpty(obj.location)) {
    obj.location = "-- NONE --";
  }

  if (isEmpty(obj.proctor)) {
    if (data.last_name) {
      obj.proctor = data.last_name;
    } else {
      obj.proctor = "-- NONE --";
    }
  }

  obj.nameShort = trimEllip(obj.nameShort, 36);
  return obj;
}
